module.exports = __webpack_public_path__ + "img/highmast_comm_fault_off.c184317c.svg";